export function renderWhatsAppButton() {
  return `
    <a
      href="https://wa.me/5511999998888"
      target="_blank"
      rel="noopener noreferrer"
      class="whatsapp-fab"
      id="whatsapp-fab"
      aria-label="Fale conosco pelo WhatsApp"
    >
      <span class="whatsapp-pulse"></span>
      <svg class="whatsapp-icon" viewBox="0 0 32 32" width="30" height="30" fill="#fff">
        <path d="M16.004 2.667A13.28 13.28 0 0 0 2.74 15.933a13.18 13.18 0 0 0 1.792 6.64L2.667 29.333l7.017-1.84a13.28 13.28 0 0 0 6.32 1.614h.005A13.34 13.34 0 0 0 29.333 15.94 13.34 13.34 0 0 0 16.004 2.667zm0 24.32a11.02 11.02 0 0 1-5.6-1.53l-.4-.24-4.16 1.09 1.112-4.06-.26-.416a10.94 10.94 0 0 1-1.68-5.9A11.07 11.07 0 0 1 16.004 4.92 11.06 11.06 0 0 1 27.08 15.94a11.07 11.07 0 0 1-11.076 11.047zm6.072-8.28c-.332-.168-1.972-.972-2.276-1.084-.308-.108-.532-.168-.756.168s-.868 1.084-1.064 1.308c-.196.224-.392.252-.724.084s-1.412-.52-2.688-1.66c-.996-.888-1.668-1.984-1.864-2.316-.196-.336-.02-.516.148-.684.152-.148.332-.392.5-.588.168-.196.224-.336.336-.556.108-.224.056-.42-.028-.588-.084-.168-.756-1.824-1.036-2.496-.272-.656-.552-.568-.756-.58-.196-.008-.42-.012-.644-.012a1.24 1.24 0 0 0-.896.42c-.308.336-1.176 1.148-1.176 2.804s1.204 3.252 1.372 3.476c.168.224 2.368 3.616 5.74 5.072.804.344 1.428.552 1.916.708.804.256 1.536.22 2.116.132.644-.096 1.972-.808 2.252-1.588.276-.78.276-1.448.196-1.588-.084-.14-.308-.224-.644-.392z"/>
      </svg>
      <span class="whatsapp-tooltip">Fale Conosco!</span>
    </a>
  `;
}
